import type { TranslationKey } from '@/lib/i18n';

export const SKIP_TO_CONTENT_LABEL = [
  'common:skipToContent.label',
  'Skip to main content',
] as const satisfies TranslationKey;
